/**
 * Точки входа лендинга с учётом состояния аутентификации.
 *
 * Лендинг открыт всем: и анониму, и уже вошедшему пользователю (он может
 * вернуться на `/`, чтобы перечитать описание продукта). Меняются только CTA —
 * анониму предлагаем регистрацию и вход, авторизованному — переход в
 * приложение.
 *
 * Модуль намеренно чистый: про сессию он не спрашивает никого сам, флаг
 * приходит снаружи (`App.tsx` → `LandingPage`). Так публичная страница
 * по-прежнему не импортирует ни `AuthService`, ни http-слой и не может
 * случайно сходить в API (SEC-1/SEC-3).
 */

import {APP_HREF, AUTHED_CTA, CTA_HREF, FINAL_CTA, HERO, LOGIN_HREF} from './content';

export interface LandingLink {
    href: string;
    label: string;
}

export interface LandingCta {
    /** Пользователь уже вошёл — витрину показываем, но зовём в приложение. */
    authenticated: boolean;
    /** Primary-кнопка шапки и hero (в каждом decision region она одна). */
    primary: LandingLink;
    /** Primary-кнопка финального блока: у анонима формулировка своя. */
    finalPrimary: LandingLink;
    /** Вторичная кнопка «Войти»; авторизованному вести туда некуда. */
    login: LandingLink | null;
    /** Текстовая ссылка футера: вход для анонима, гардероб для вошедшего. */
    footer: LandingLink;
}

/** Собирает набор ссылок лендинга под текущее состояние сессии. */
export const landingCta = (authenticated: boolean): LandingCta => {
    if (authenticated) {
        const app: LandingLink = {href: APP_HREF, label: AUTHED_CTA.primary};
        return {
            authenticated: true,
            primary: app,
            finalPrimary: app,
            login: null,
            footer: {href: APP_HREF, label: AUTHED_CTA.secondary},
        };
    }

    const login: LandingLink = {href: LOGIN_HREF, label: FINAL_CTA.secondary};
    return {
        authenticated: false,
        primary: {href: CTA_HREF, label: HERO.primaryCta},
        finalPrimary: {href: CTA_HREF, label: FINAL_CTA.primary},
        login,
        footer: login,
    };
};
